import { createFileRoute } from "@tanstack/react-router";
import { RelatorioProdutorFaixaLitragem } from "pages/relatorios/pages/produtor_faixa_litragem";

export const Route = createFileRoute("/a/relatorios/produtor-faixa-litragem")({
	component: RelatorioProdutorFaixaLitragem,
});
